import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { IAuthSlice, Me } from 'entities/auth/types';
import { AppStorage as storageService } from 'shared/services';

const token = storageService.get('access_token');
const initialState: IAuthSlice = {
  isLogged: !!token,
  token: token || null,
  me: null,
};

const authSlice = createSlice({
  name: 'authSlice',
  initialState,
  reducers: {
    setLogIn(state, action: PayloadAction<{ access_token: string; refresh_token: string }>) {
      state.isLogged = true;
      state.token = action.payload.access_token;
      storageService.set('access_token', action.payload.access_token);
      storageService.set('refresh_token', action.payload.refresh_token);
    },
    setLogOut(state) {
      state.isLogged = false;
      state.token = null;
      storageService.remove('access_token');
      storageService.remove('refresh_token');
    },
    setMe(state, action: PayloadAction<Me>) {
      state.me = action.payload;
    },
  },
});

export const { setLogIn, setLogOut, setMe } = authSlice.actions;

export default authSlice.reducer;
